// Simple imperative navigation helper to use React Router from non-component modules
// Usage:
//  - Call setNavigator(navigateFn) once in a component (e.g., at app root)
//  - Call navigate(path, options) from anywhere (e.g., baseQuery) to perform client-side navigation

let navigatorRef = null;

export const setNavigator = (navigateFn) => {
  navigatorRef = typeof navigateFn === 'function' ? navigateFn : null;
};

export const navigate = (to, options) => {
  if (navigatorRef) {
    try { navigatorRef(to, options); return; } catch { /* fallthrough */ }
  }
  // Fallback to hard navigation only if navigator not yet available
  try {
    if (typeof window !== 'undefined' && window.location) {
      if (options && options.replace) window.location.replace(to);
      else window.location.assign(to);
    }
  } catch { /* noop */ }
};

